document.addEventListener('DOMContentLoaded', function() {
  console.log('Discount handler loaded');
  
  // Function to get URL parameters
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // Get discount code from URL parameter
  var discountCode = getUrlParameter('discount');
  console.log('Detected discount code:', discountCode);
  
  // If discount code exists in URL, apply it to cart
  if (discountCode) {
    console.log('Attempting to apply discount:', discountCode);
    
    // Store in localStorage to persist across pages
    localStorage.setItem('shopifyDiscountCode', discountCode);
    
    // Apply to cart using Shopify Cart API
    fetch('/discount/' + discountCode, {
      method: 'GET',
      credentials: 'same-origin'
    })
    .then(function(response) {
      console.log('Discount response status:', response.status);
      if (response.ok) {
        console.log('Discount applied successfully:', discountCode);
        // Optionally refresh the page to show the discount
        // window.location.reload();
      } else {
        console.error('Error applying discount code - Status:', response.status);
      }
    })
    .catch(function(error) {
      console.error('Fetch error when applying discount:', error);
    });
  } else {
    // Check if we have a stored discount code from a previous page
    var storedDiscount = localStorage.getItem('shopifyDiscountCode');
    console.log('Checking for stored discount:', storedDiscount);
    
    if (storedDiscount) {
      console.log('Applying stored discount:', storedDiscount);
      // Apply stored discount code
      fetch('/discount/' + storedDiscount, {
        method: 'GET',
        credentials: 'same-origin'
      })
      .then(function(response) {
        console.log('Stored discount response status:', response.status);
        if (response.ok) {
          console.log('Stored discount applied successfully:', storedDiscount);
        } else {
          console.error('Error applying stored discount code - Status:', response.status);
        }
      })
      .catch(function(error) {
        console.error('Fetch error when applying stored discount:', error);
      });
    }
  }
});